<template>
    <v-flex xs12 class="businesses businesses__filters__block panelBlock">
        <v-flex tag="h2">
            {{businessesConstants.REFINE_BY}}
            <button 
                class="clearallbtn"
                @click="resetFilters"
                :disabled="!isFiltersEmpty"
                data-qe-id="clearAllBtn">{{businessesConstants.CLEAR_ALL_FILTERS}}
            </button>
        </v-flex>
        <v-layout row wrap class="businesses__filters">
            <v-flex sm4>
                <v-flex class="businesses-options">
                    <h6>{{assetSummaryConstants.ESTABLISHMENT}}</h6>
                    <v-list>
                        <v-list-tile v-for="(item, index) in assetSummaryConstants.establishmentTypes" 
                            :key="index"
                            :disabled="checkDisabled('establishments',item)"
                            @click.stop="toggleColor('establishments',item)">
                            <v-layout row>
                                <v-flex>
                                    {{item}}
                                </v-flex>

                                <v-flex>
                                    <v-checkbox :data-qe-id="'establishmentTypeFilter_chk'+index"
                                                multiple
                                                v-model="filters.establishments"
                                                :value="item"
                                                :disabled="checkDisabled('establishments',item)"
                                                @click.stop="toggleColor('establishments',item)"
                                                color="$ypo_blue" hide-details>
                                    </v-checkbox>
                                </v-flex>
                            </v-layout>
                        </v-list-tile>
                    </v-list>
                </v-flex>
                <v-flex class="businesses-options">
                    <h6>{{businessesConstants.CUISINE_CATAGORY}}</h6>
                    <v-list>
                        <v-flex class="businesses-options__list-body inner-scrollbar">
                            <v-list-tile v-for="(item, index) in assetSummaryConstants.cuisineTypes" 
                                :key="index" 
                                :disabled="checkDisabledForCuisine('cuisineTypes',item)"
                                @click.stop="toggleColor('cuisineTypes',item)">
                                <v-layout row>
                                    <v-flex>
                                        {{item}}
                                    </v-flex>
                                    <v-flex>
                                        <v-checkbox
                                                :data-qe-id="'cuisineFilter_chk'+index"
                                                color="$ypo_blue"
                                                multiple
                                                v-model="filters.cuisineTypes"
                                                :value="item"
                                                :disabled="checkDisabledForCuisine('cuisineTypes',item)"
                                                @click.stop="toggleColor('cuisineTypes',item)"
                                                hide-details>
                                        </v-checkbox>
                                    </v-flex>
                                </v-layout>
                            </v-list-tile>
                        </v-flex>
                    </v-list>
                </v-flex>
            </v-flex>
            <v-flex sm4>
                <v-flex class="businesses-options">
                    <h6>{{assetSummaryConstants.ACCOMODATION}}</h6>
                    <v-list>
                        <v-list-tile v-for="(item, index) in assetSummaryConstants.accommodationTypes" 
                            :key="index"
                            :disabled="checkDisabled('accommodationTypes',item)" 
                            @click.stop="toggleColor('accommodationTypes',item)">
                            <v-layout row>
                                <v-flex>
                                    {{item}}
                                </v-flex>
                                <v-flex>
                                    <v-checkbox
                                            :data-qe-id="'accommodationFilter_chk'+index"
                                            color="$ypo_blue"
                                            multiple
                                            v-model="filters.accommodationTypes"
                                            :value="item"
                                            :disabled="checkDisabled('accommodationTypes',item)"
                                            @click.stop="toggleColor('accommodationTypes',item)"
                                            hide-details>
                                    </v-checkbox>
                                </v-flex>
                            </v-layout>
                        </v-list-tile>
                    </v-list>
                </v-flex>
                <v-flex class="businesses-options">
                    <h6>{{businessesConstants.PRICE}}</h6>
                    <v-list>
                        <v-list-tile v-for="(item, index) in assetSummaryConstants.priceRange" 
                            :key="index"
                            :disabled="checkDisabled('prices',item)"  
                            @click.stop="toggleColor('prices',item)">
                            <v-layout row>
                                <v-flex>
                                    {{item}}
                                </v-flex>
                                <v-flex>
                                    <v-checkbox
                                            :data-qe-id="'priceFilter_chk'+index"
                                            multiple
                                            v-model="filters.prices"
                                            :value="item"
                                            :disabled="checkDisabled('prices',item)"
                                            @click.stop="toggleColor('prices',item)"
                                            color="$ypo_blue"
                                            hide-details>
                                    </v-checkbox>
                                </v-flex>
                            </v-layout>
                        </v-list-tile>
                    </v-list>
                </v-flex>
                <v-flex class="businesses-options">
                    <h6 class="distance-switch">{{businessesConstants.DISTANCE}} 
                        <v-switch v-model="distanceSwitch"
                            color="ypo_blue"
                            data-qe-id="distancefilter_switch"
                            @change="onDistanceSwitch()"
                            :label="`${distanceSwitch ? businessesConstants.MILES: businessesConstants.KILOMETERS}`">
                        </v-switch>
                    </h6>
                    <v-list>
                        <v-list-tile v-for="(item, index) in [1,2,5,10,25]" 
                            :key="index"
                            :disabled="checkDisabled('distances',item)"  
                            @click.stop="toggleColor('distances',item)">
                            <v-layout row>
                                <v-flex>
                                    {{item}}
                                </v-flex>
                                <v-flex>
                                    <v-checkbox
                                            :data-qe-id="'distanceFilter_chk'+index"
                                            multiple
                                            v-model="filters.distances"
                                            :value="item"
                                            :disabled="checkDisabled('distances',item)"
                                            @click.stop="toggleColor('distances',item)"
                                            color="$ypo_blue"
                                            hide-details>
                                    </v-checkbox>
                                </v-flex>
                            </v-layout>
                        </v-list-tile>
                    </v-list>
                </v-flex>
            </v-flex>
            <v-flex sm4>
                <v-flex class="businesses-options">
                    <h6>{{assetSummaryConstants.HOTEL_CLASS}}</h6>
                    <v-list>
                        <v-list-tile v-for="(item, index) in assetSummaryConstants.hotelClass" 
                            :key="index"
                            :disabled="checkDisabled('hotelClassTypes',item)" 
                            @click.stop="toggleColor('hotelClassTypes',item)">
                            <v-layout row>
                                <v-flex>
                                    {{item}}
                                </v-flex>
                                <v-flex>
                                    <v-checkbox
                                            :data-qe-id="'hotelClassFilter_chk'+index"
                                            color="$ypo_blue"
                                            multiple
                                            v-model="filters.hotelClassTypes"
                                            :value="item"
                                            :disabled="checkDisabled('hotelClassTypes',item)"
                                            @click.stop="toggleColor('hotelClassTypes',item)"
                                            hide-details>
                                    </v-checkbox>
                                </v-flex>
                            </v-layout>
                        </v-list-tile>
                    </v-list>
                </v-flex>
                <v-flex class="businesses-options">
                    <h6>{{assetSummaryConstants.STAR_RATING}}</h6>
                    <v-list>
                        <v-list-tile v-for="(item, index) in [1,2,3,4,5]" 
                            :key="item"
                            :disabled="checkDisabled('starRatings',item)"
                            @click.stop="toggleColor('starRatings',item)">
                            <v-layout row>
                                <v-flex v-for="i in item" :key="i" class="stars">
                                    <v-icon :disabled="checkDisabled('starRatings',item)" color="$ypo_blue">star</v-icon>
                                </v-flex>
                                <v-flex>
                                    <v-checkbox
                                        :data-qe-id="'starratingFilter_chk'+index"
                                        color="$ypo_blue"
                                        multiple
                                        v-model="filters.starRatings"
                                        :value="item"
                                        :disabled="checkDisabled('starRatings',item)"
                                        @click.stop="toggleColor('starRatings',item)"
                                        hide-details>
                                    </v-checkbox>
                                </v-flex>
                            </v-layout>
                        </v-list-tile>
                    </v-list>
                </v-flex>
            </v-flex>
        </v-layout>
        <!-- <v-layout row wrap class="businesses__filters">
            <v-flex xs12 sm4>
                <v-menu attach v-model="showOwnershipTypes" :close-on-content-click="false" transition="slide-y-transition" offset-y>
                    <v-flex slot="activator">
                        <v-btn class="filter-btn" id="establishment_fiterBtn" data-qe-id="establishment_fiterBtn">
                            <i v-if="!showOwnershipTypes" class="fas fa-plus-square"></i>
                            <i v-if="showOwnershipTypes" class="fas fa-minus-square"></i>  
                            {{businessesConstants.OWNERSHIP_TYPE}}&nbsp;{{filters.ownershipTypes.length > 0 ? `(${filters.ownershipTypes.length})`:'' }}
                        </v-btn>
                    </v-flex>
                    <v-flex class="businesses-options">
                        <v-list>
                            <v-subheader>{{businessesConstants.OWNERSHIP_TYPE}}</v-subheader>
                            <v-list-tile v-for="(item, index) in businessesConstants.OWNERSHIP_TYPES" 
                                :key="index"
                                :disabled="checkDisabledForOwnertype('ownershipTypes',item)"
                                @click.stop="toggleColor('ownershipTypes',item)">
                                {{item}}
                                <v-checkbox :data-qe-id="'ownershipTypeFilter_chk'+index"
                                    multiple
                                    v-model="filters.ownershipTypes"
                                    :value="item"
                                    :disabled="checkDisabledForOwnertype('ownershipTypes',item)"
                                    @click.stop="toggleColor('ownershipTypes',item)"
                                    color="$ypo_blue" hide-details>
                                </v-checkbox>
                            </v-list-tile>
                        </v-list>
                    </v-flex>
                </v-menu>
            </v-flex>
        </v-layout> -->
    </v-flex>
</template>

<script>
    import { businessesConstants, filterMethods, emptyFilters } from './businesses.constants';
    import { assetSummaryConstants } from '../MemberProfile/memberProfile.constants';

    export default {
        name: "BusinessFilters",
        data() {
            return {
                assetSummaryConstants,
                businessesConstants,
                distanceSwitch: true,
                filters: emptyFilters,
            };
        },
        props: {
            filtersEnabled: {
                type: Object,
                required: false,
            },
            filtersUpdationDate: {
                type: Number,
                required: false,
                default: 0,
            },
        },
        methods: {
            ...filterMethods,
            onDistanceSwitch() {
                this.filters.distances = [];
                this.$emit('distanceSwitch', this.distanceSwitch);
            },
        },
        computed: {
            isFiltersEmpty() {
                return Object.values(this.filters).some(f => f.length > 0);
            },
        },
        watch: {
            filters: {
                handler(newval) {
                    this.$emit('filters', newval);
                },
                deep: true,
            },
            filtersUpdationDate(val) {
                if (val) {
                    const updatedFiltesrs = {
                        establishments: [],
                        cuisineTypes: [],
                        accommodationTypes: [],
                        starRatings: [],
                        prices: [],
                        hotelClassTypes: [],
                        ownershipTypes: [],
                        distances: [],
                    };
                    Object.keys(this.filters).forEach((filter) => {
                        const filterValues = this.filters[filter];
                        if (filterValues.length > 0) {
                            filterValues.forEach((item) => {
                                if (this.filtersEnabled[filter].some(x => x.includes(item))) {
                                    updatedFiltesrs[filter].push(item);
                                }
                            });
                        }
                    });
                    this.filters = updatedFiltesrs;
                }
            },
        },
    };
</script>

<style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .businesses {
        &__filters {
            margin-bottom: 20px;
            .filter-btn {
                margin: 0 10px 10px 0;
                font-size: 12px;
                color: $white;
                background-color: $ypo-cta !important;
                box-shadow: none !important;
                text-transform: uppercase;
                border-radius: 3px;
                font-weight: 600;
                i {
                    font-size: 22px;
                    padding-left: 5px;
                    font-weight: 600;
                }
            }

            .v-menu__content {
                box-shadow: none;
            }
            .v-menu__activator--active {
                .filter-btn {
                    .fa-sort-down {
                        &::before {
                            content: "\F0DE";
                        }
                    }
                } 
            }
            &__block {
                margin-bottom: 15px;
                padding: 3px 0;
                background-color: $ypo-extra-light-gray;
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                z-index: 10;
                h3 {
                    font-size: 13px;
                    color: $ypo-blue;
                    padding: 8px 10px;
                    border-bottom: 1px solid rgba($ypo-medium-gray, 0.5);
                    margin-bottom: 10px;
                }
                .clearallbtn {
                    position: absolute;
                    padding: 10px 10px;
                    right: 20px;
                    top: 0px;
                    color: $ypo-cta;
                    font-size: 14px;                       
                    font-weight: 600;
                    font-family: Noto Sans, sans-serif;                     
                    &:hover {
                        color: $ypo-blue;
                    }
                    &:disabled {
                        color: $ypo-gray;
                    }
                    &:focus {
                        outline: none;
                    }
                }
                .applybtn {
                    position: absolute;
                    padding: 10px 10px;
                    right: 80px;
                    top: 0px;
                    color: $ypo-cta;
                    font-size: 14px;                       
                    font-weight: 600;
                    font-family: Noto Sans, sans-serif;                     
                    &:hover {
                        color: $ypo-blue;
                    }
                    &:disabled {
                        color: $ypo-gray;
                    }
                    &:focus {
                        outline: none;
                    }
                }
            }
        } 
    }

    .businesses-options {
        margin: 10px;
        h6 {
            font-size: 16px;
            font-weight: 500;
            font-family: 'Raleway', sans-serif;
            margin-bottom: 10px;
            margin-top: 20px;
            margin-left: 5px;
        }
        .v-list {
            background-color: $white;
            box-shadow: 0 1px 3px 0 rgba($black, 0.18);
            border: 1px solid rgba($ypo-gray, 0.4);
            border-radius: 3px;
            
            .v-subheader {
                border-bottom: 1px solid $ypo-open-blue-gray;
                margin-bottom: 10px;
                color: $ypo-blue;
            }
            
            .v-list__tile {
                font-size: 12px;
                height: 30px;
                position: relative;
                padding-right: 40px;
                cursor: pointer;

                &:hover {
                    color: $ypo-cta;
                }

                .v-input {
                    position: absolute;
                    right: 0;
                    @include breakpoint(md) {
                        top: 5px;
                    }
                    .v-icon {
                        font-size: 18px;
                        color: $ypo-blue;
                    }
                }

                .stars {
                    flex: none;
                    .v-icon {
                        font-size: 18px;
                        color: $ypo-blue;
                        padding-right: 10px;
                    }
                }
            }
        }
        &__list-body {
            max-height: 300px;
            overflow-y: auto;
            overflow-x: hidden;
        }
        
        .distance-switch {
            display: flex;
            position: relative;
            .v-input {
                padding: 0;
                width: auto;
                height: auto;
                margin: 0;
                position: absolute;
                right: 0;
                top: 0;
            }
        }            
    }

    @include breakpoint(xs) {
        .businesses {
            &__filters {
                padding: 0;
                margin-bottom: 0px;
                .v-menu--inline {
                    .v-btn__content {
                        justify-content: left;
                    }
                }
                &__block {
                    position: inherit;
                    z-index: 1;
                }
            }
        }
    }
</style>
